var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { M } from 'src/Utils';
export var RightPanelContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n\n  ", "\n\n  @media (max-width: ", "px) {\n    gap: 16px;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n\n  ",
    "\n\n  @media (max-width: ", "px) {\n    gap: 16px;\n  }\n"])), function (_a) {
    var fullHeight = _a.fullHeight;
    return fullHeight &&
        "\n    height: 100%;\n    align-self: stretch;\n\n    & > *:first-of-type {\n      height: 100%;\n    }\n  ";
}, M);
var templateObject_1;
